<template>
    <div class="hotel-filter-list">
      <template v-if="!selectedGroup">
        <div v-for="(item, key) in list" :key="key">
            <div class="hotel-filter-item" v-if="item.isShow && !(item.isDisabled && !value[item.Key])" >
                <checkbox v-model="value[item.Key]"
                          :disabled="item.isDisabledAndShow"
                          @change="$emit('change-tour-hotel', item.Key, $event)">

                    <span v-if="item.Resort != null" class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                        {{item.Name + ' ' + (item.Stars || '')}} {{'(' + item.Resort.Name + ')'}}
                    </span>

                    <span v-else class="ellipsis" :title="item.Name + ' ' + (item.Stars || '')">
                        {{item.Name + ' ' + (item.Stars || '')}}
                    </span>
                </checkbox>
            </div>
        </div>
      </template>

      <template v-else>
        <accordion-list v-for="(sublist, heading) in sortedList" :key="heading">
            <template #trigger>
              <p v-if="sublist.every(el => el.isShow)" class="hotel-filter-group">{{ heading }} {{ getHotelCheckedAmount(sublist) }}</p>
            </template>

            <div v-for="(subitem, subidx) in sublist" :key="subidx">
              <div class="hotel-filter-item" v-if="subitem.isShow && !(subitem.isDisabled && !value[subitem.Key])" >
                  <checkbox v-model="value[subitem.Key]"
                            :disabled="subitem.isDisabledAndShow"
                            @change="$emit('change-tour-hotel', subitem.Key, $event)">

                    <span v-if="subitem.Resort != null" class="ellipsis" :title="subitem.Name + ' ' + (subitem.Stars || '')">
                        {{subitem.Name + ' ' + (subitem.Stars || '')}} {{'(' + subitem.Resort.Name + ')'}}
                    </span>

                    <span v-else class="ellipsis" :title="subitem.Name + ' ' + (subitem.Stars || '')">
                        {{subitem.Name + ' ' + (subitem.Stars || '')}}
                    </span>
                  </checkbox>
              </div>
            </div>
        </accordion-list>
      </template>
        
      <div v-show="!list.length || list.every((item) => item.isDisabled)">
            <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
      </div>
    </div>
</template>

<script>
import accordionList from './accordionList.vue';  
export default {
  name: "hotel-filter-list",
  props: {
    value: {
      type: Object,
      default: () => {},
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      default: () => [],
    },
    showSelectedHotels: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedGroup() {
      return this.groups.find((item) => item.isChecked);
    },
    groupedList() { // Array or Object
      if (this.selectedGroup.name === 'country') {
        return this.getGroupedList('Country')
      }

      if (this.selectedGroup.name === 'city') {
        return this.getGroupedList('City')
      }

      if (this.selectedGroup.name === 'resort') {
        return this.getGroupedList('Resort')
      }

      return this.list 
    },
    sortedList() {
      if (Array.isArray(this.groupedList)) return this.groupedList

      return Object.keys(this.groupedList)
          .sort((a, b) => {
            if (a === this.localizeList.groupNoneTitle) return 1;
            if (b === this.localizeList.groupNoneTitle) return -1;
            return a.localeCompare(b);
          })
          .reduce((acc, el) => {
            acc[el] = this.groupedList[el];
            return acc;
          }, {});
    }
  },
  methods: {
    getHotelCheckedAmount(list) {
      const selectedHotels = list.filter(item => item.isSelected);

      if (this.showSelectedHotels) {
        return `(${selectedHotels.length})`;
      } else if (!selectedHotels.length && list.length) {
        return `(${list.length})`;
      } else if (selectedHotels.length && list.length) {
        return `(${selectedHotels.length}/${list.length})`;
      } else {
        return "";
      }
    },
    getGroupedList(prop) {
      return this.list.reduce((acc, el) => {
          if (!el.isShow) return acc

          const isSelected = this.value[el.Key]

          const title = el[prop]?.Name || el[prop]?.name || this.localizeList.groupNoneTitle
          acc[title] ??= []
          acc[title].push({ ...el, isSelected })

          return acc
        }, {})
    },
  },
  components: {
    accordionList
  }
};
</script>

<style scoped>
.hotel-filter-list {
  height: calc(100% - 26.5px);
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--lighten-7-color);
  padding: 5px;
  overflow-y: scroll;
}

.hotel-filter-group {
  font-weight: 500;
  font-size: 18px;
}

.hotel-filter-item {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
</style>